import React from 'react';
import styled from '@emotion/styled';
import { RecaptchaProps } from '../types/recatptcha-props';

type Props = Pick<RecaptchaProps, 'error' | 'errorText'>;

const Container = styled.span`
  color: var(--olymp-robot-error, #f15132);
  font-size: var(--text-caption3-size, 11px);
  line-height: 1.36;
`;

const RecaptchaError: React.FC<Props> = ({ error, errorText }) => {
  if (!error) {
    return;
  }
  return <Container>{errorText}</Container>;
};

export default React.memo(RecaptchaError);
